// extracted by mini-css-extract-plugin
export default {"titleBlock":"TitleBlock_titleBlock__Vy+ed","titleRow":"TitleBlock_titleRow__4Dan3"};